import '@aarsteinmedia/dotlottie-player-light'
import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";

export default () => ({
    init() {
		const swiper = new Swiper(this.$root.querySelector(".swiper"), {
			modules: [Scrollbar],
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
			},
			slidesPerView: 1.6,
			spaceBetween: 150,
			watchSlidesProgress: true,
			breakpoints: {
				640: {
					slidesPerView: 2.6,
				},
				1024: {
					slidesPerView: 3.6,
				},
			},
		});
    }
})